module.exports = __webpack_public_path__ + "static/media/yunying8.8170d0ee.jpg";